<template>
    <SlideWrapper :moduleType="moduleType">
        <template v-slot:wrapper="slotProps">

            <section 
                v-bind="slotProps.attributes"
                :aria-hidden="slotProps.states.hidden.toString()" 
            >
                <component
                    v-for="(slide, x) in slides"
                    :is="'SlideItem'"
                    :key="'s-' + x"
                    :titleTag="isMobile() ? 'h2' : 'h1'"
                    :hasOutline="x < slides.length - 1"
                    :hasDiscoverPath="true"
                    :slide="slide"
                    :playing="slotProps.states.playing"
                />
            </section>

        </template>
    </SlideWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { discoverConfig } from '@/router/module/shared'
import { browser, setup } from '@/mixins/main'

import { slidesBeforeEnter, slidesParallax } from '@/helpers/helperSlides'
// import { showSlidesStories, hideSlidesStories } from '@/helpers/helperStories'

import SlideWrapper     from '../SlideWrapper'
import SlideItem        from '../Slide/SlideItem'

const { titles, alias, duration } = discoverConfig

export default {
    name: 'DiscoverSlides',

    props: {
        source: String, 
        poster: String,
    },

    components: {
        SlideWrapper,
        SlideItem, 
        // AsyncStories: () => import(/* webpackChunkName: "ui-async-stories" */ '../Story/Index')
    },

    mixins: [
        browser,
        setup,
    ],

    data: () => ({
        transitionName: '',
        moduleType: 'discover',
    }),

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.transitionName = 'load'

            slidesBeforeEnter.call(vm, alias, titles)
        })
    },

    deactivated() {
        this.$root.$off('slides-refresh')
        this.$root.$off('show-stories')
        this.$root.$off('hide-stories')
    },

    activated() {
        // this.afterSlideActivated()

        // Slides
        this.$root.$on('slides-refresh', () => {
            slidesBeforeEnter.call(this, alias, titles, false)
        })

        // Stories
        this.$root.$on('show-stories', ({ cb }) => {
            cb instanceof Function && cb()
        })
    },

    methods: {
        afterSlideActivated() {
            if ( this.isMobile() ) {
                return;
            }
            return setTimeout(() => {
                const delayMs = this.currentSlide === 5 ? 0 : 1600
                !this.activeElement && this.restorePageFocus('.is-active h1, .is-active h2', delayMs)
            }, 100)
        },
        afterSlideChange( slide ) {
            return setTimeout(() => {
                this.disableFocusables( slide )
                this.restorePageFocus('.is-active h1, .is-active h2', 1600)
            }, 100)
        },
        ...mapMutations({
            setVisibleStories: 'setVisibleStories',
            slideNav: 'discover/slideNav',
            slideSet: 'discover/slideSet',
            storySet: 'discover/storySet'
        })
    },

    computed: {
        ...mapGetters({
            user: 'user',
            slides: 'discover/slides',
            currentSlide: 'discover/currentSlide',
            stories: 'discover/stories'
        })
    },

    watch: {
        async currentSlide( slide, oldSlide ) {
            const { path } = this.$route

            if ( this.isMobile() || path.includes('campus') || path.includes('connect') ) {
                return;
            }

            const slideParams = [slide, alias, titles, duration, (slide - oldSlide)]
            await slidesParallax.call(this, ...slideParams)
            
            this.afterSlideChange(slide)
            
        },
    }
}
</script>
